import { useState } from "react";
import { ICommentSettingsProps } from "interfaces";
import CommentSettingsPopover from "./commentSettingsPopover";

const CommentSettingsInDesktop = ({ commentId, isReply, replies, setReplies, setRepliesCount }: ICommentSettingsProps) => {
    const [showPopover, setShowPopover] = useState<boolean>(false);

    return (
        <div className="pl-relative">
            <button className="pl-flex pl-flex-col pl-items-center pl-gap-0.5" onClick={() => setShowPopover(true)}>
                <span className="pl-w-[3px] pl-h-[3px] pl-rounded-full pl-bg-secondary-500"></span>
                <span className="pl-w-[3px] pl-h-[3px] pl-rounded-full pl-bg-secondary-500"></span>
                <span className="pl-w-[3px] pl-h-[3px] pl-rounded-full pl-bg-secondary-500"></span>
            </button>
            {showPopover && (
                <CommentSettingsPopover
                    setShowPopover={setShowPopover}
                    commentId={commentId}
                    isReply={isReply}
                    replies={replies}
                    setReplies={setReplies}
                    setRepliesCount={setRepliesCount}
                />
            )}
        </div>
    );
};

export default CommentSettingsInDesktop;
